/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-alert */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import firebase from 'firebase'
import _ from 'lodash'
import moment from 'moment'
import Select from 'react-select'
import ImageCompressor from 'image-compressor.js'
import { Form, Button, Image, Dimmer, Loader, Grid, TextArea, Input } from 'semantic-ui-react'

import RestaurantActions from '../../../reducers/restaurantReducer'
import ImageUpload from '../../../services/ImageUpload'

class AppInboxForm extends Component {
  state = {
    image: null,
    compressImage: null,
    restaurant: null,
    title: {
      en: '',
      kh: '',
    },
    description: {
      en: '',
      kh: '',
    },
    startFrom: null,
    expiredAt: null,
    createdAt: moment().format('x'),
    compressing: false,
    uploading: false,
    saving: false,
    isImageDeleted: false,
  }

  componentDidMount() {
    const { restaurantLoaded, fetchRestaurants, action } = this.props

    if (!restaurantLoaded) {
      fetchRestaurants()
    }

    if (action === 'edit') {
      const { appInboxData } = this.props
      const { start_from: startFrom, expired_at: expiredAt, created_at: createdAt } = appInboxData
      this.setState({
        image: appInboxData.image,
        compressImage: appInboxData.compress_image,
        title: appInboxData.title,
        description: appInboxData.description,
        restaurant: appInboxData.restaurant || null,
        startFrom: startFrom !== null ? Number(startFrom) : null,
        expiredAt: expiredAt !== null ? Number(expiredAt) : null,
        createdAt: Number(createdAt),
      })
    }
  }

  onFormSubmit = () => {
    this.setState({ saving: true }, () => {
      this.saveData()
    })
  }

  onTextChange = (field, locale, value) => {
    this.setState(prevState => ({
      [field]: {
        ...prevState[field],
        [locale]: value,
      },
    }))
  }

  onChangeRestaurant = restaurant => {
    this.setState({ restaurant })
  }

  onRangeChange = (type, value) => {
    let newValue

    if (type === 'startFrom' && value !== '') {
      newValue = moment(value)
        .startOf('day')
        .format('x')
    } else if (type === 'expiredAt' && value !== '') {
      newValue = moment(value)
        .endOf('day')
        .format('x')
    } else {
      newValue = null
    }

    this.setState({ [type]: newValue })
  }

  onImageChange = e => {
    const file = e.target.files[0]

    if (file) {
      this.compress(file)
    }
  }

  compress = file => {
    const self = this
    this.setState({ compressing: true })

    const imageCompressor = new ImageCompressor()

    imageCompressor
      .compress(file, { quality: 0.6 })
      .then(result => {
        self.setState({ compressing: false, uploading: true, isImageDeleted: false }, () => {
          self.upload(result)
        })
      })
      .catch(() => {
        alert('There is problem while while compressing file. Please try again.')
      })
  }

  upload = async file => {
    const { firebaseKey } = this.props
    try{
      const imageUploader = new ImageUpload(file, 'image', {
        destination: `app_inboxes/${firebaseKey}`,
        type: `apin_image`,
        manipulation: {
          width: 700,
          height: 0,
          size: 15000,
        },
      })
      const { originalUrl, compressUrl } = await imageUploader.upload()
      this.setState({ uploading: false, image: originalUrl, compressImage: compressUrl })
    }catch(err) {
      alert('There is problem while uploading file. Please try again.', err)
    }
  }

  saveData = async () => {
    try {
      await this.deleteImageFromStorage()

      const {
        image,
        compressImage = null,
        title,
        restaurant,
        description,
        expiredAt,
        startFrom,
        createdAt,
      } = this.state

      const { firebaseKey, history, action } = this.props

      const updates = {
        image,
        compress_image: compressImage,
        title,
        description,
        restaurant: _.size(restaurant) > 0 ? restaurant : null,
        expired_at: Number(expiredAt),
        start_from: Number(startFrom),
        updated_at: Number(moment().format('x')),
        created_at: Number(createdAt),
      }

      const doc = firebase
        .firestore()
        .collection('app_inboxes')
        .doc(firebaseKey)

      if (action === 'edit') {
        await doc.update(updates)

        this.setState({ saving: false }, () => {
          history.push('/app-inbox')
        })
      } else {
        await doc.set(updates)

        this.setState({ saving: false }, () => {
          history.push('/app-inbox')
        })
      }
    } catch (error) {
      alert(error.message || error)
    }
  }

  generateDropDownRestaurants = () => {
    const { restaurants } = this.props
    const selectOptions = []

    _.forEach(restaurants, (restaurant, key) => {
      if (restaurant.status === 'publish') {
        selectOptions.push({
          value: key,
          label: restaurant.name,
        })
      }
    })

    return selectOptions
  }

  deleteImageFromStorage = async () => {
    const self = this
    const { image, compressImage, isImageDeleted } = this.state
    if (!isImageDeleted) return
    const imageRef = firebase.storage().refFromURL(image)
    const compressImageRef = firebase.storage().refFromURL(compressImage)

    await Promise.all([imageRef.delete(), compressImageRef.delete()])
      .then(() => self.setState({ image: null, compressImage: null }))
      .catch(err => alert(err))
  }

  shouldDisabled = () => {
    const { title, description, compressing, uploading, startFrom, expiredAt } = this.state

    const loading = compressing || uploading
    const isTitleEmpty = title.en === '' || title.kh === ''
    const isDescriptionEmpty = description.en === '' || description.kh === ''
    const eitherStartOrEnd =
      (startFrom != null && expiredAt === null) || (startFrom === null && expiredAt != null)

    return isTitleEmpty || isDescriptionEmpty || loading || eitherStartOrEnd
  }

  render() {
    const {
      compressing,
      uploading,
      image,
      title,
      description,
      restaurant,
      saving,
      startFrom,
      expiredAt,
      isImageDeleted,
    } = this.state
    const { action, restaurantLoading } = this.props

    const loading = compressing || uploading
    const imageUrl = !isImageDeleted && image ? image : require('../../../assets/images/placeholder-480.png')

    const start = startFrom != null ? moment(parseInt(startFrom, 10)).format('YYYY-MM-DD') : null
    const endAt = expiredAt != null ? moment(parseInt(expiredAt, 10)).format('YYYY-MM-DD') : null

    return (
      <Form loading={restaurantLoading}>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Form.Field
                required
                control={Input}
                value={title.en}
                label="Title in English"
                onChange={e => this.onTextChange('title', 'en', e.target.value)}
              />
              <Form.Field
                required
                control={TextArea}
                value={description.en}
                label="Description in English"
                onChange={e => this.onTextChange('description', 'en', e.target.value)}
              />
              <Form.Field>
                <label>Start From</label>
                <input
                  type="date"
                  value={start}
                  onChange={e => this.onRangeChange('startFrom', e.target.value)}
                />
              </Form.Field>
              <Form.Field>
                <label>To</label>
                <input
                  type="date"
                  value={endAt}
                  onChange={e => this.onRangeChange('expiredAt', e.target.value)}
                />
              </Form.Field>
              <Form.Field>
                <label>Restaurant</label>
                <Select
                  isClearable
                  isRtl={false}
                  isSearchable
                  name="restaurant"
                  value={restaurant}
                  isDisabled={false}
                  className="basic-single"
                  classNamePrefix="select"
                  onChange={this.onChangeRestaurant}
                  options={this.generateDropDownRestaurants()}
                />
              </Form.Field>
            </Grid.Column>

            <Grid.Column>
              <Form.Field
                required
                control={Input}
                label="Title in Khmer"
                value={title.kh}
                onChange={e => this.onTextChange('title', 'kh', e.target.value)}
              />
              <Form.Field
                required
                control={TextArea}
                label="Description in Khmer"
                value={description.kh}
                onChange={e => this.onTextChange('description', 'kh', e.target.value)}
              />
              <Form.Field>
                <label>Image (640x360)</label>
                <input
                  hidden
                  type="file"
                  accept="image/*"
                  onChange={e => this.onImageChange(e)}
                  ref={input => {
                    this.imageInput = input
                  }}
                />
                <Image
                  src={imageUrl}
                  className="image-previewer-sponsor"
                  onClick={!image ? () => this.imageInput.click() : null}
                  dimmer={
                    <Dimmer active={loading}>
                      <Loader />
                    </Dimmer>
                  }
                />
                {image && (
                  <div style={{ marginTop: 5 }}>
                    <Button size="tiny" content="Change" onClick={() => this.imageInput.click()} />
                    <Button
                      size="tiny"
                      color="red"
                      content="Delete"
                      onClick={() => this.setState({ isImageDeleted: true })}
                    />
                  </div>
                )}
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Button
          type="submit"
          color="black"
          loading={saving}
          style={{ marginTop: 10 }}
          disabled={this.shouldDisabled()}
          onClick={() => this.onFormSubmit()}
        >
          {action === 'edit' ? 'Update' : 'Save'}
        </Button>
      </Form>
    )
  }
}

const mapState = state => ({
  restaurants: state.restaurants.data,
  restaurantLoaded: state.restaurants.loaded,
  restaurantLoading: state.restaurants.loading,
})

const mapDispatch = {
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,
}

export default connect(
  mapState,
  mapDispatch
)(withRouter(AppInboxForm))



// WEBPACK FOOTER //
// ./src/containers/appInbox/components/form.js